import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import { ExternalStorageHomeLayout } from '../../layouts/ExternalStorage'

const ExternalStorageHome = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>External Storage</title>
      <meta name="description" content="External Storage page" />
    </Helmet>
    <ExternalStorageHomeLayout />
  </React.Fragment>
)

export default ExternalStorageHome
